import axios from 'axios';

const ele: HTMLElement | null = document.getElementById('page-loading');

const Instance = axios.create({
    baseURL: process.env.REACT_APP_SOA_BASE_URL,
    headers: {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        'Accept-Language': localStorage.getItem('language') || 'en'
    }
});

interface dataResponse extends Express.Response {
    data: {
        result: {
            status: string;
            token: string;
        };
    };
}

export const generateOTP = async (phoneNumber: string) => {
    const config = {
        method: 'post',
        url: `${process.env.REACT_APP_DRIVER_URL}generateOTP/${phoneNumber}`
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const validateOTP = async (phoneNumber: string, otp: string) => {
    const config = {
        method: 'post',
        url: `${process.env.REACT_APP_DRIVER_URL}validateOTP/${phoneNumber}`,
        data: { otp }
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const getDrivers = async () => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'get',
        url: process.env.REACT_APP_DRIVER_URL,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const getDriverByPhoneNumber = async (phoneNumber: string) => {
    const language = localStorage.getItem('language');
    const url = `${process.env.REACT_APP_DRIVER_URL}phoneNumber/${phoneNumber}`;

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        'Accept-Language': language,
        phoneNumber
    };

    const config = {
        method: 'get',
        url,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const postDriver = async (phoneNumber: string, name: string) => {
    const token = localStorage.getItem('token');

    const language = localStorage.getItem('language');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'post',
        url: process.env.REACT_APP_DRIVER_URL,
        headers,
        data: {
            phoneNumber,
            name
        }
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const updateDriver = async (driverId: string, name: string) => {
    const token = localStorage.getItem('token');

    const language = localStorage.getItem('language');

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const updateValue = {
        name
    };

    const config = {
        method: 'put',
        url: `${process.env.REACT_APP_DRIVER_URL}update/${driverId}`,
        headers,
        data: {
            updateValue
        }
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const updateLanguagePreference = async (
    driverId: string,
    languagePreference: 'en' | 'es' | 'ru'
) => {
    const token = localStorage.getItem('token');

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    };

    const updateValue = {
        languagePreference
    };

    const config = {
        method: 'put',
        url: `${process.env.REACT_APP_DRIVER_URL}update/${driverId}`,
        headers,
        data: {
            updateValue
        }
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const postPrecheckTransaction = async (
    submittedName: string,
    submittedPhoneNumber: string,
    submittedReferenceId: string,
    submittedDotNumber: string,
    plantId: string,
    orgId: string,
    submittedVisitType: string,
    submittedLanguage: string,
    trailerAttached: boolean,
    submittedTrailerNumber: string,
    submittedTrailerLength: string,
    isOrderFound: boolean,
    manhTripId: string,
    manhDeliveryId: string,
    manhCustomerPo: string,
    manhCarrierName: string,
    manhCarrierSCAC: string,
    manhCustomerName: string,
    manhAddress: string,
    manhVisitType: string,
    manhPickupAppointment: Date,
    manhDeliveryAppointment: Date
) => {
    const USDOT = submittedDotNumber === '' ? "NA" : submittedDotNumber;
    const precheck = {
        submittedName,
        submittedPhoneNumber,
        submittedReferenceId,
        plantId,
        submittedDotNumber: USDOT,
        orgId,
        isOffsite: true,
        submittedVisitType,
        submittedLanguage,
        manhVisitType,
        trailerAttached,
        submittedTrailerNumber,
        submittedTrailerLength,
        isOrderFound,
        manhTripId,
        manhDeliveryId,
        manhCustomerPo,
        manhCarrierName,
        manhCarrierSCAC,
        manhCustomerName,
        manhAddress,
        manhPickupAppointment,
        manhDeliveryAppointment
    };

    const token = localStorage.getItem('token');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': submittedLanguage,
        submittedReferenceId
    };

    const config = {
        method: 'post',
        url: `${process.env.REACT_APP_PRECHECK_URL}create`,
        headers,
        data: { precheck }
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const getPrecheckById = async (precheckId: string) => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'get',
        url: `${process.env.REACT_APP_PRECHECK_URL}id/${precheckId}`,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error: any) {
            return error;
        });
};

export const getDriverActivePrecheck = async (phoneNumber: string) => {
    const language = localStorage.getItem('language');
    const token = localStorage.getItem('token');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'get',
        url: `${process.env.REACT_APP_PRECHECK_URL}phoneNumber/${phoneNumber}`,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const updatePrecheck = async (precheckId: string, updateValue: object, language: string) => {
    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        // Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        precheckId
    };

    const config = {
        method: 'put',
        url: `${process.env.REACT_APP_PRECHECK_URL}update/${precheckId}`,
        data: {
            updateValue
        },
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const getPlantByCode = async (orgCode: string) => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language');
    const driverId = localStorage.getItem('driverId') || '';

    const url = process.env.REACT_APP_PLANT_URL + `code/${orgCode}`;

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'get',
        url: url,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const queryShipment = async (driverId: string, referenceId: string, plantId: string) => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language') || 'en';

    const url = new URL(`${process.env.REACT_APP_MANHATTAN_URL}queryOrder` as string);
    url.searchParams.append('driverId', driverId);
    url.searchParams.append('referenceId', referenceId);
    url.searchParams.append('language', language);
    url.searchParams.append('plantId', plantId);
    const urlStr = url.toString();

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        driverId
    };

    const config = {
        method: 'get',
        url: urlStr,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

export const getCarrierList = async () => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language');
    const driverId = localStorage.getItem('driverId') || '';

    const headers = {
        app_version: '1.0.0',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Accept-Language': language,
        driverId
    };

    const config = {
        method: 'get',
        url: process.env.REACT_APP_CARRIERS_URL,
        headers
    };

    return await Instance(config)
        .then(function (response: dataResponse) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};

Instance.interceptors.request.use(
    async function (config) {
        if (ele) ele.classList.remove('d-none');
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

Instance.interceptors.response.use(
    async function (response) {
        if (ele) ele.classList.add('d-none');

        return response;
    },
    async function (error) {
        if (ele) ele.classList.add('d-none');

        return Promise.reject(error);
    }
);
